import { trackingApis } from '@apis/trackingDataApis';
import { createUseQuery } from '@hooks/createUseQuery';

export const useTrackingDataList = createUseQuery(
  (trackNos: string[]) => ['/tracking-data/list/', { trackNos }],
  (trackNos) => () =>
    trackingApis
      .get('/tracking-data/list/', {
        query: {
          track_no: trackNos,
        },
      })
      .then((r) => r[200]),
);
